import styled from "styled-components";

export const ContainerResultTable = styled.div`
    max-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px 24px;
`

export const ContainerTableColumns = styled.div`
  display: flex;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;     
  min-width: 0;  
`;

export const ColumnName = styled.p`
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    color: #373A3E;

    padding: 14px 12px;
    border-bottom: 1px solid #D8DCDE;
    width: 100%;
`

export const ColumnValue = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #373A3E;
  padding: 16px 12px;
`;
export const Status = styled.p`
    max-width: 33%;
    border-radius: 2px;
    gap: 4px;
    padding-top: 2px;
    padding-right: 8px;
    padding-bottom: 2px;
    padding-left: 8px;
    background: #BF5000;

    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;


    color: #FFFFFF;
`